import { Suspense } from "react";

import PaymentSelectorVector from "./payment-vector";

type PaymentSummaryData = {
  prices: {
    eligible: boolean;
    depositAmount: string;
    collectionAmount: string;
    annualPercentageRate: string;
    numberOfCollections: number;
    costOfCredit: string;
    totalCost: string;
    firstPayment: string;
    creditChargeRate: string;
  };
  monthlyPaySummaryTitle: string;
  summarayData: SummarayData[];
  totalPriceRow: string;
  fullPayAmount: string;
};

type PriceKey = keyof PaymentSummaryData["prices"];

type SummarayData = {
  title: string;
  key: string;
};

function MonthlyPaymentSummary(props: Readonly<PaymentSummaryData>) {
  const {
    prices,
    monthlyPaySummaryTitle,
    summarayData,
    totalPriceRow,
    fullPayAmount,
  } = props;

  const paymentSummaryRows = () => {
    const renderPrice = (key: PriceKey) => {
      if (key === "annualPercentageRate") return `${prices[key]}% APR`;
      if (key === "creditChargeRate") return `${prices[key]}%`;
      if (key === "totalCost") return `£${fullPayAmount}`;

      return `£${prices[key]}`;
    };

    return summarayData.map((data) => {
      return (
        <div
          key={data.title}
          className="flex justify-between items-start self-stretch w-full max-h-[32px] h-full py-spacing-xxs px-0
                          border-b-[1px] border-b-surface-neutral-option-4"
        >
          <div className="font-proxima-nova text-[16px] not-italic font-normal leading-[24px] text-text-functional">
            {data.key === "collectionAmount"
              ? `${prices.numberOfCollections} x ${data.title}`
              : data.title}
          </div>
          <div className="text-right text-text-functional font-proxima-nova not-italic font-bold leading-[24px]">
            {data.key === "fixedInterestRate"
              ? renderPrice("creditChargeRate")
              : renderPrice(data.key as PriceKey)}
          </div>
        </div>
      );
    });
  };

  return (
    <div
      className="flex flex-col items-start w-full h-fit px-spacing-m py-spacing-m gap-spacing-s self-stretch
                rounded-radius-lg border-[1px] border-surface-neutral-option-4 bg-surface-neutral-option-1"
    >
      <div className="flex items-start self-stretch md:w-full md:h-full gap-spacing-xs">
        <div className="  md:w-auto md:h-auto font-sub-section-header-font text-[20px] not-italic font-bold leading-[23px] text-text-title">
          {monthlyPaySummaryTitle}
        </div>
      </div>
      <div className="flex flex-col items-start self-stretch w-full h-full rounded-radius-lg">
        {paymentSummaryRows()}

        <div className="flex justify-between items-start self-stretch w-full h-full py-spacing-xxs px-0">
          <div className="text-text-functional font-body-font text-[16px] not-italic font-bold leading-[24px]">
            {totalPriceRow}
          </div>
          <div className="text-right text-text-functional font-body-font not-italic font-bold leading-[24px]">
            {`£${prices.totalCost}`}
          </div>
        </div>
      </div>
      <div className="flex justify-end items-start self-stretch w-full h-full px-0">
        <div>
          <Suspense fallback={<div>Loading...</div>}>
            <PaymentSelectorVector />
          </Suspense>
        </div>
      </div>
    </div>
  );
}

export default MonthlyPaymentSummary;
